import { Injectable } from '@angular/core';
import * as rxjs from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DataService {
  private messageSource = new rxjs.BehaviorSubject<any>([]);
  currentMessage = this.messageSource.asObservable();

  private messagePhoneBackSource = new rxjs.BehaviorSubject<any>([]);
  currentMessagePhoneBack = this.messagePhoneBackSource.asObservable();

  private typeLoadSource = new rxjs.BehaviorSubject<any>([]);
  currentTypeLoad = this.typeLoadSource.asObservable();

  private loadTotalSeenSource = new rxjs.BehaviorSubject<any>([]);
  currentTotalSeen = this.loadTotalSeenSource.asObservable();

  private routeOrder = new rxjs.BehaviorSubject<any>([]);
  routeOrderMessage = this.routeOrder.asObservable();
  constructor() {}

  changeMessage(message: string) {
    this.messageSource.next(message);
  }
  changePhoneBackNumberMessage(message: string) {
    this.messagePhoneBackSource.next(message);
  }
  changeTypeLoad(typeLoad: string) {
    this.typeLoadSource.next(typeLoad);
  }

  changeTotalSeen(loadTotalSeen: string) {
    this.loadTotalSeenSource.next(loadTotalSeen);
  }

  changeRouteOrder(message: any) {
    this.routeOrder.next(message);
  }
}
